import React, { useContext, useEffect } from "react";
import Table from "./Table";
import Risk from "./sub-components/Cards/Risk";
import GrowthGraph from "./sub-components/Cards/GrowthGraph";
import RegionDestribution from "./sub-components/Cards/RegionDestribution";
import Allocation from "./sub-components/Cards/Allocation";
import Text from "./sub-components/Cards/Text";
import FundContext from "@/components/FundSingle/FundProvider";
import RiskAndRating from "./sub-components/Cards/RiskAndRating";
import ReturnsYearly from "./sub-components/Cards/ReturnsYearly";
import Fees from "./sub-components/Cards/Fees";
import RiskAnalysis from "./sub-components/Cards/RiskAnalysis";
import ModernPortfolioTheory from "./sub-components/Cards/ModernPortfolioTheory";
import Returns from "./sub-components/Cards/Returns";
import MSStyleBox from "./sub-components/Cards/MSStyleBox";
import QuarterlyReturns from "./sub-components/Cards/QuarterlyReturns";
import BranchDistributions from "./sub-components/Cards/BranchDistributions";
import MarketValue from "./sub-components/Cards/MarketValue";
import ValueEstimatesAndGrowth from "./sub-components/Cards/ValueEstimatesAndGrowth";
import PortfolioStatistics from "./sub-components/Cards/PortfolioStatistics";
import LargestHoldings from "./sub-components/Cards/LargestHoldings";
import FundInfo from "./sub-components/Cards/FundInfo";
import LargestBranches from "./sub-components/Cards/LargestBranches";

export interface FundComponentStructureInterface {
  type: string;
  label?: string;
  slug?: string;
  rows?: any[];
  url?: string;
}

const generateFundComponentStructure = () => {
  const { fundRiskDetails, portfolio } = useContext(FundContext);

  var largestHoldings;

  useEffect(() => {
    largestHoldings = portfolio?.PortfolioHoldings?.slice(0, 5);
  }, [fundRiskDetails, portfolio]);

  if (!fundRiskDetails) return null;

  // Showrisk depends on if fundRiskDetails has property RiskAndRating or not
  const showRisk = !!(
    fundRiskDetails?.RiskAndRating && fundRiskDetails.RiskAndRating.length > 0
  );

  return [
    {
      type: "components",
      label: "Översikt",
      slug: "oversikt",
      rows: [
        [<GrowthGraph withSettings={true} growth10={true} />],
        [<RegionDestribution />],
        [
          portfolio.GlobalStockSectorBreakdown ? <LargestBranches /> : null,
          <LargestHoldings topFive={true} />,
        ],
        [<Returns short={true} />, <Allocation />],
        [
          <Text
            title="Placeringsinriktningar"
            text={fundRiskDetails.InvestmentStrategy}
          />,
          <MSStyleBox />,
        ],
        [<FundInfo />, showRisk ? <Risk /> : null],
        [<Fees />],
      ],
    },
    {
      type: "components",
      label: "Diagram",
      slug: "diagram",
      rows: [[<GrowthGraph withSettings={true} />]],
    },
    {
      type: "components",
      label: "Historik",
      slug: "historik",
      rows: [
        [<GrowthGraph growth10={true} />],
        [<ReturnsYearly />],
        [<Returns />, <QuarterlyReturns />],
      ],
    },
    {
      type: "components",
      label: "Risk och rating",
      slug: "risk-och-rating",
      rows: [
        [showRisk ? <RiskAndRating /> : null],
        [<ModernPortfolioTheory />, <RiskAnalysis />],
      ],
    },
    {
      type: "components",
      label: "Innehav",
      slug: "innehav",
      rows: [
        [
          <LargestHoldings />,
          fundRiskDetails.Portfolios?.[0]?.GlobalStockSectorBreakdown ? (
            <BranchDistributions />
          ) : null,
        ],
        [
          <MSStyleBox />,
          portfolio.MarketCapitalBreakdown ? <MarketValue /> : null,
        ],
        [<ValueEstimatesAndGrowth />, <Allocation />],
        [<RegionDestribution />],
        [<PortfolioStatistics />],
      ],
    },
    {
      type: "components",
      label: "Avgifter",
      slug: "avgifter",
      rows: [[<Fees />]],
    },
    {
      type: "seperator",
    },
    {
      type: "link",
      label: "Förvaltare & Fakta",
      url: "#fundManagers",
    },
  ];
};

export default generateFundComponentStructure;
